import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      d: "M2.445 16.045c0 .346.191.537.528.537h18.063c.327 0 .527-.191.527-.537V6.973c0-.337-.2-.537-.527-.537H2.973c-.337 0-.528.2-.528.537zm.919-.59V7.563c0-.137.063-.21.2-.21h16.872c.137 0 .21.073.21.21v7.89c0 .137-.073.21-.21.21H3.564c-.137 0-.2-.073-.2-.21m8.6 1.127c1.963 0 3.527-1.973 3.527-5.082 0-3.1-1.564-5.064-3.527-5.064-1.91 0-3.446 1.964-3.446 5.064 0 3.109 1.536 5.082 3.445 5.082m0-1.073c-1.291 0-2.391-1.536-2.391-4.01 0-2.463 1.1-3.99 2.39-3.99 1.346 0 2.482 1.527 2.482 3.99 0 2.474-1.136 4.01-2.482 4.01"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#464646",
      d: "M0 18.3c0 .436.29.727.727.727h22.555c.436 0 .718-.29.718-.727V4.718c0-.436-.282-.718-.718-.718H.727C.291 4 0 4.282 0 4.718zm1.464-1V5.727c0-.2.072-.263.263-.263h20.546c.2 0 .263.063.263.263V17.3c0 .19-.063.264-.263.264H1.727c-.19 0-.263-.073-.263-.264"
    }, null, -1)
  ])))
}
export default { render: render }